import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import VueTheMask from "vue-the-mask";
import vClickOutside from "v-click-outside";
import TextareaAutosize from "vue-textarea-autosize";
import VueModal from "vue-js-modal/dist/ssr.nocss";
import svg4everybody from "svg4everybody";
import VeeValidate from "vee-validate";

// TODO: refactoring need
import "promise-polyfill/src/polyfill";
import "core-js/fn/object/assign";

import { webSocket } from "./webSocket";
import { vhUpdate } from "./resizeScreen";
import { sentry } from "./sentry";
import { veeValidator } from "./veeValidator";
import { i18n } from "@v2/shared/config";

export const initPlugins = () => {
  window.addEventListener("resize", vhUpdate);
  vhUpdate();

  webSocket();
  sentry();
  svg4everybody();
  veeValidator();

  Vue.use(VueScrollTo)
    .use(VueTheMask)
    .use(vClickOutside)
    .use(TextareaAutosize)
    .use(VueModal, {
      componentName: "global-modal"
    })
    .use(VeeValidate, {
      locale: i18n.locale
    });
};
